import type { FaireProductEntity } from "../../entity_types/product";

export const p_jekxx342fp: FaireProductEntity = {
  token: "p_jekxx342fp",
  type: "product",
  name: "Bloom - Essential Oil Coconut Soy 8oz Candle",
  brandToken: "b_f2njjv4jzw",
  brandName: "Milk Jar Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/8b652a1fde1b710d6a3d2295279734b523e6d26085ddc366a1d8f460e9358447.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2a87114bcfdf4757ea237eef0ea4bf22f97e236ccdc43130302dc7d954ea6734.jpeg",
    "https://cdn.faire.com/fastly/3082a676151391ee50b9a08024f4ee0edabfc175d7a5a3826f43319d1acb8662.jpeg",
    "https://cdn.faire.com/fastly/0004eb0ec458e2e8125691ac2c3b47da1419297032f0bdf879d930ca0b6e9d3f.jpeg",
    "https://cdn.faire.com/fastly/1dee5b6647e93670d6a53cfc1db4129250a96afdbde934fa0cfe23456c500dc6.jpeg",
    "https://cdn.faire.com/fastly/234af265e00ac375da21afd4cb7f01c09b7d1e29d758d10f19e4e36bd50547a2.jpeg",
    "https://cdn.faire.com/fastly/5146fcd337796604d08785f399d00cc60cc450dd0e124efd7c13bc365babece7.jpeg",
    "https://cdn.faire.com/fastly/2aa1fd060e34163ab8d4d1a7b32990104b719637e1044711964cfa5ef4ce381a.jpeg",
    "https://cdn.faire.com/fastly/d6c340088249d93d645e64d779a27472d3f9fdfbdaf009f12179e272d1ef849e.jpeg",
    "https://cdn.faire.com/fastly/618deb7365ab1c8d8d4def9c0d4ae6684d2c86071fd48506ee3a0196bae1bf0d.jpeg",
    "https://cdn.faire.com/fastly/f54c7881c0cce88205eb8e4ddcd79fbe70e9ecda97f585caeb5625692d2a7ba8.jpeg",
    "https://cdn.faire.com/fastly/6c951e0668d61ac76500a4fc38c57a6bec265e0c4ca14fe94b761798d4c09415.jpeg",
    "https://cdn.faire.com/fastly/40d1b4d60eac9ae8cf359a6297128ee2ee38e4e7e8eb6b363c9e9e412f0e5b93.jpeg",
  ],
  priceDollars: 15.94,
  description:
    "Lavender, Ylang-Ylang, Vetiver & Wormwood · 8 oz Essential Oil Candle - (New Glass Colour) \n\nCome, let us tip-toe through the tulips. Or maybe more accurately, the lavender. We can bring a picnic, make angels in the pollen and generally get our frolic on. Afterwards, we’ll stop at gam gam’s house, and bask in the most wholesome-ass afternoon imaginable.\n\n$1 from every candle sold supports the creation of inclusive and inviting spaces around the world · Crackling wooden wick · Plant based coconut soy wax · Scented with high quality, natural essential oils · Vegan and cruelty-free · 40-45 hour burn time with proper wick trimming · Hand-poured in sunny Calgary",
  tags: [],
  msrpDollars: 31.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:00.656Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
